import InMemory from './in-memory'

export { InMemory }

export default InMemory
